import { Navigate } from "react-router-dom";

const Signup = () => <Navigate to="/login" replace />;

export default Signup;
